import __request__ from "routing/request";
export function getAllRetrievalResults(paginationparameters, filters, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/data_lake/retrievals", paginationparameters, { "filters": filters }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
